import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, Phone, MessageCircle, Home } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { Button } from './ui/button';
import { company, waLink, fireAdsConversion } from '../mock';

export default function ThankYou() {
  const fired = useRef(false);
  const location = useLocation();
  useEffect(() => {
    // Fire conversions (Google Ads + GA4 + OpenAI Ads pixel) exactly once on load
    if (!fired.current) {
      fired.current = true;
      fireAdsConversion(location.state && location.state.eventId);
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {/* Blue hero band */}
        <section className="pt-[112px] lg:pt-[130px] bg-primary text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-grid opacity-20" />
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/15 mb-6">
              <CheckCircle2 className="w-9 h-9 text-white" />
            </div>
            <h1 className="text-4xl lg:text-6xl font-extrabold font-display leading-tight">
              Thanks for visiting
            </h1>
            <p className="mt-4 text-xl lg:text-2xl text-white/90 font-medium">
              We will connect you soon!
            </p>
            <p className="mt-4 max-w-xl text-white/80">
              Your request has been received successfully. One of our compliance experts will reach out
              to you shortly on the details you provided.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-4">
              <Button asChild className="w-full sm:w-auto inline-flex items-center justify-center bg-white text-primary hover:bg-white/90 font-semibold rounded-full px-7 h-14 text-base leading-none">
                <a href={`tel:${company.phoneRaw}`}><Phone className="w-5 h-5 mr-2" /> Call Now</a>
              </Button>
              <Button asChild className="w-full sm:w-auto inline-flex items-center justify-center bg-[#25D366] hover:bg-[#1fb457] text-white font-semibold rounded-full px-7 h-14 text-base leading-none">
                <a href={waLink()} target="_blank" rel="noreferrer"><MessageCircle className="w-5 h-5 mr-2" /> Chat on WhatsApp</a>
              </Button>
              <Button asChild variant="outline" className="w-full sm:w-auto inline-flex items-center justify-center border-2 border-white/60 text-white hover:bg-white hover:text-primary font-semibold rounded-full px-7 h-14 text-base leading-none bg-transparent">
                <Link to="/"><Home className="w-5 h-5 mr-2" /> Back to Home</Link>
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
